import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import routes from 'routes';
import * as webhookHelpers from './webhook.helpers';
import * as webhookActions from './webhook.actions';
import { webhookTypes } from './webhook.types';
import { handleErrors, getNotifMsg } from 'utils';
import {
  createWebhooksObject,
  createWebhookObject,
  convertStatusToEnabled,
  getWebhookStatus,
} from './webhook.adapter';

const mapState = ({ appData }) => ({
  locale: appData.locale,
});

export function* fetchAllWebhooks() {
  const { locale } = yield select(mapState);

  try {
    yield put(webhookActions.loadingWebhooks());
    const fetchedData = yield webhookHelpers.handleFetchAllWebhooks(locale);
    yield put(
      webhookActions.setFetchedWebhooks(createWebhooksObject(fetchedData.data))
    );
  } catch (error) {
    handleErrors(error, locale);
  }
}

export function* onFetchAllWebhooks() {
  yield takeLatest(webhookTypes.FETCH_WEBHOOKS_START, fetchAllWebhooks);
}

export function* addNewWebhook({ payload }) {
  const { webhookObj, history } = payload;
  const { locale } = yield select(mapState);

  try {
    const addWebhookRes = yield webhookHelpers.handleAddNewWebhook(
      webhookObj,
      locale
    );
    if (addWebhookRes.status === 201) {
      // enable created webhook
      // const webhookId = addWebhookRes.data.data.hookId;
      // yield webhookHelpers.handleToggleWebhookEnable(webhookId);

      yield put(
        webhookActions.setNewAddedWebhook(
          createWebhookObject(addWebhookRes.data.data)
        )
      );

      toast.success(getNotifMsg('NEW_WEBHOOK_ADDED', locale));
    }

    history.push(routes.webhookList);
  } catch (error) {
    handleErrors(error, locale);
  }
}

export function* onAddNewWebhook() {
  yield takeLatest(webhookTypes.ADD_WEBHOOK, addNewWebhook);
}

export function* toggleWebhookEnable({ payload }) {
  const { locale } = yield select(mapState);

  const STATUS_TEXT_LOCALE = {
    fa: {
      enabled: 'فعال',
      disabled: 'غیرفعال',
    },
    en: {
      enabled: 'enabled',
      disabled: 'disabled',
    },
  };

  try {
    yield put(webhookActions.setWebhookStatusLoading(payload.webhookId));
    const response = yield webhookHelpers.handleToggleWebhookEnable(
      payload.webhookId,
      locale
    );
    const { isGivenUp, _id: webhookId } = response.data;
    const enabled = convertStatusToEnabled(isGivenUp);

    const status = enabled
      ? STATUS_TEXT_LOCALE[locale].enabled
      : STATUS_TEXT_LOCALE[locale].disabled;

    yield put(webhookActions.setWebhookStatus(webhookId, enabled));
    toast.success(getWebhookStatus(status, locale));
  } catch (error) {
    handleErrors(error, locale);
  }
}

export function* onToggleWebhookEnable() {
  yield takeLatest(webhookTypes.TOGGLE_WEBHOOK_ENABLE, toggleWebhookEnable);
}

function* editWebhook({ payload }) {
  const { webhookObj, history } = payload;
  const { locale } = yield select(mapState);

  try {
    const response = yield webhookHelpers.handleEditWebhook(webhookObj, locale);
    yield put(
      webhookActions.setEditedWebhook(createWebhookObject(response.data))
    );
    toast.success(getNotifMsg('SUCCESSFULL_EDITING', locale));
    history.push(routes.webhookList);
  } catch (error) {
    handleErrors(error, locale);
  }
}

export function* onEditWebhook() {
  yield takeLatest(webhookTypes.EDIT_WEBHOOK_START, editWebhook);
}

export default function* webhooksSagas() {
  yield all([
    call(onFetchAllWebhooks),
    call(onAddNewWebhook),
    call(onToggleWebhookEnable),
    call(onEditWebhook),
  ]);
}
